import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-bakerycarnival',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bakerycarnival.html',
  styleUrl: './bakerycarnival.css',
})
export class Bakerycarnival {}
